import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider, Tooltip } from 'antd'
import { isFunction, isObject, isUndefined } from 'lodash'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

import '../../assets/student-sheet.scss'

export const ELEMENT_TYPES = {
  DIVIDER: 'divider',
  COLLAPSE: 'collapse',
  SPACE: 'space'
}

const InformationDisplay = ({ entity, hideTitle, information }) => {
  const t = useSelector(selectTranslate)

  const useEntity = isObject(entity)

  return (
    <div className='information-displayer-container'>
      {
        information.map((i, index) => {
          let content = null

          if (i.type === ELEMENT_TYPES.COLLAPSE) {
            content = React.cloneElement(i.caption, { key: 'collapse' + index })
          } else if (i.type === ELEMENT_TYPES.DIVIDER) {
            content = <Divider key={'divider' + index} style={{ margin: '12px 0px 0px 0px' }} />
          } else if (i.type === ELEMENT_TYPES.SPACE) {
            content = <div key={'space' + index} style={{ height: '10px' }} />
          } else if (useEntity) {
            const title = isFunction(i.title) ? i.title(entity, t) : t(i.title)
            const body = isUndefined(i.isValid) || (isFunction(i.isValid) && i.isValid(entity)) ? i.body(entity, t) : t(i.title + '.without')

            content = (
              <div key={title + '_' + index} className='information-line flex-row' style={{ marginBottom: '5px' }}>
                <div style={{ width: '20px' }}>
                  <FontAwesomeIcon icon={i.icon} />
                </div>
                <div style={i.style ?? {}} className={i.color ? 'flex-column text-color-' + i.color : 'flex-column'}>
                  <b>{title}</b>
                  {body}
                </div>
              </div>
            )
          } else {
            content = (
              <Tooltip placement='left' title={typeof hideTitle === 'undefined' ? '' : i.title} key={`${i.id}_${index}`}>
                <div className='information-line flex-row' style={{ marginBottom: '5px' }}>
                  <div style={{ width: '20px' }}>
                    <FontAwesomeIcon icon={i.icon} />
                  </div>
                  <div style={i.style ?? {}} className={i.color ? 'flex-column text-color-' + i.color : 'flex-column'}>
                    {typeof hideTitle === 'undefined' ? <b>{i.title}</b> : null}
                    {i.caption}
                  </div>
                </div>
              </Tooltip>
            )
          }

          return content
        })
      }
    </div>
  )
}

export default InformationDisplay
